import { OptionsType, setCookie } from "cookies-next";
import { jwtDecode } from "jwt-decode";
import { string } from "mathjs";

import { encode } from "./encryption";
import { APP, TOKEN, USER_TYPE } from "./enum";

interface HandleLogin {
  access_token: string;
  organization_id?: number;
  full_name?: string;
  organization_unique_link?: string;
  user_type?: USER_TYPE;
  username?: string;
}

interface JWTDecoded {
  token_type: "access" | "refresh";
  exp: number; // Expiry date
  iat: number; // Issued at
  jti: string; // JWT ID
  user_id: string; // User ID
}

export function handleLogin({
  full_name,
  access_token,
  user_type = USER_TYPE.STAFF,
  username,
  organization_id,
  organization_unique_link,
}: HandleLogin) {
  const [header, payload, signature] = access_token.split(".") as [
    header: string,
    payload: string,
    signature: string
  ];

  const decoded = jwtDecode<JWTDecoded>(access_token);

  const options = {
    secure: true,
    maxAge: decoded.exp - decoded.iat,
    sameSite: "strict",
  } satisfies OptionsType;

  setCookie(TOKEN.HEADER, header, options);
  setCookie(TOKEN.PAYLOAD, payload, options);
  setCookie(TOKEN.SIGNATURE, signature, options);

  setCookie(APP.EXPANDED_NAVBAR, "true", options);

  if (organization_id) {
    setCookie(APP.ORGANIZATION_ID, string(organization_id), options);
  }

  if (organization_unique_link) {
    setCookie(APP.UNIQUE_LINK, organization_unique_link, options);
  }

  if (username) {
    setCookie(APP.USER_NAME, username, {
      ...options,
      sameSite: "lax",
      encode,
    });
  }

  if (full_name) {
    setCookie(APP.FULL_NAME, full_name, {
      ...options,
      sameSite: "lax",
      encode,
    });
  }

  if (user_type) {
    setCookie(APP.USER_TYPE, user_type, {
      ...options,
      sameSite: "lax",
      encode,
    });
  }
}
